<admin-app-header></admin-app-header>

<div class="profile-page">
    <div class="profile-header">
        <div class="profile-avatar">
            <i class="fa-solid fa-user"></i>
        </div>
        <div class="profile-info">
            <h1>{{ userName || 'Admin User' }}</h1>
            <p>{{ userEmail }}</p>
        </div>
    </div>

    <div class="card">
        <h2><i class="fa-solid fa-envelope"></i> Email (SMTP) Settings</h2>
        <p class="hint">Configure your SMTP details so you can send outreach emails directly from the CRM. Replies will come to your inbox.</p>

        <div class="loading-state" *ngIf="smtpLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>

        <ng-container *ngIf="!smtpLoading">
            <div class="form-grid">
                <div>
                    <label class="field-label">SMTP Host</label>
                    <input type="text" [(ngModel)]="smtp.host" placeholder="smtp.gmail.com" />
                </div>
                <div>
                    <label class="field-label">Port</label>
                    <input type="number" [(ngModel)]="smtp.port" placeholder="587" />
                </div>
                <div>
                    <label class="field-label">Username</label>
                    <input type="text" [(ngModel)]="smtp.user" placeholder="you@company.com" />
                </div>
                <div>
                    <label class="field-label">Password</label>
                    <input type="password" [(ngModel)]="smtp.password" placeholder="App password or SMTP password" />
                </div>
                <div>
                    <label class="field-label">From Name</label>
                    <input type="text" [(ngModel)]="smtp.fromName" placeholder="Your Name" />
                </div>
                <div>
                    <label class="field-label">From Address</label>
                    <input type="text" [(ngModel)]="smtp.fromAddress" placeholder="you@company.com" />
                </div>
            </div>

            <label class="field-label">Email Signature</label>
            <p class="hint">Copy your signature from your email client and paste it directly below. The formatting will be preserved.</p>
            <div class="sig-editor">
                <div class="sig-tabs">
                    <button [class.active]="sigTab === 'visual'" (click)="switchToVisual()"><i class="fa-solid fa-eye"></i> Visual</button>
                    <button [class.active]="sigTab === 'code'" (click)="switchToCode()"><i class="fa-solid fa-code"></i> HTML Source</button>
                </div>
                <div
                    *ngIf="sigTab === 'visual'"
                    #sigEditor
                    class="sig-visual"
                    contenteditable="true"
                    (input)="onSigInput()"
                    [innerHTML]="smtp.signature || ''"
                    data-placeholder="Paste your formatted email signature here..."
                ></div>
                <textarea
                    *ngIf="sigTab === 'code'"
                    rows="12"
                    class="sig-code"
                    [ngModel]="smtp.signature"
                    (ngModelChange)="onSigCodeChange($event)"
                    placeholder="Raw HTML source..."
                    spellcheck="false"
                ></textarea>
            </div>

            <div class="btn-row">
                <button class="primary-btn" [disabled]="smtpSaving" (click)="saveSmtp()">
                    <i class="fa-solid" [class.fa-spinner]="smtpSaving" [class.fa-spin]="smtpSaving" [class.fa-floppy-disk]="!smtpSaving"></i>
                    {{ smtpSaving ? 'Saving...' : 'Save Settings' }}
                </button>
                <button class="secondary-btn" [disabled]="smtpTesting" (click)="testSmtp()">
                    <i class="fa-solid" [class.fa-spinner]="smtpTesting" [class.fa-spin]="smtpTesting" [class.fa-plug]="!smtpTesting"></i>
                    {{ smtpTesting ? 'Testing...' : 'Test Connection' }}
                </button>
            </div>

            <div class="alert alert--ok" *ngIf="smtpMessage">{{ smtpMessage }}</div>
            <div class="alert alert--err" *ngIf="smtpError">{{ smtpError }}</div>
        </ng-container>
    </div>
</div>
